import { MaterialBalanceTimeChartProducts } from "constants/chart.constants";
import { EvaChartFeatures } from "types";

export const applyMaterialBalanceTimeSettingsOnChartSwitch = (
  sessionDataObj,
  overrides: EvaChartFeatures
) => {
  if (!MaterialBalanceTimeChartProducts.includes(sessionDataObj?.product)) {
    sessionDataObj.product = MaterialBalanceTimeChartProducts[0];
  }
  overrides.spaghetti.active = true;
};
